import { render, staticRenderFns } from "./rs-form-wizard.vue?vue&type=template&id=b70e24ea&scoped=true"
import script from "./rs-form-wizard.vue?vue&type=script&lang=js"
export * from "./rs-form-wizard.vue?vue&type=script&lang=js"
import style0 from "./rs-form-wizard.vue?vue&type=style&index=0&id=b70e24ea&prod&scoped=true&lang=css"
import style1 from "./rs-form-wizard.vue?vue&type=style&index=1&id=b70e24ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70e24ea",
  null
  
)

export default component.exports